
export const data = [
    { 
        title: 'Explore',
        options: [
            { title: 'Parks & Nature' },
            { title: 'Dining & Retail' },
            { title: 'Education, Medical & Transport' },
            { title: 'Lifestyle, Sport & Wellness' },
        ]
    },
];